import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { logoutAndRedirect } from '../../actions/auth'

export function requireAuthentication(Component) {
  const RequireAuthentication = props => {
    const dispatch = useDispatch()
    const isAuthenticated = useSelector(state => state.auth.isAuthenticated)

    useEffect(() => {
      if (!sessionStorage.getItem('oef-token')) {
        dispatch(logoutAndRedirect(false, true))
      }
    })

    return isAuthenticated ? <Component {...props} /> : null
  }

  RequireAuthentication.propTypes = {
    isAuthenticated: PropTypes.bool,
    dispatch: PropTypes.func,
    location: PropTypes.object,
    history: PropTypes.object
  }

  return RequireAuthentication
}
